export enum LanguageIntensity {
  Soft = 'soft',
  Intense = 'intense',
  Rough = 'rough',
}
